import type { NavigateFunction } from 'react-router-dom'
import { stripCreatePrefillParams } from '@/lib/create-biddle-prefill'

/** Open the property profile modal via `?property=` on the current (or given) path. */
export function openPropertyProfile(
  navigate: NavigateFunction,
  propertyId: string,
  opts?: { pathname?: string; replace?: boolean; create?: boolean },
) {
  const pathname = opts?.pathname ?? window.location.pathname
  const params = new URLSearchParams(
    pathname === window.location.pathname ? window.location.search : '',
  )
  params.delete('biddle')
  params.delete('biddleProperty')
  params.set('property', propertyId)
  if (opts?.create) params.set('create', '1')
  else {
    params.delete('create')
    stripCreatePrefillParams(params)
  }
  const search = `?${params.toString()}`
  navigate({ pathname, search }, { replace: opts?.replace })
}

/** Open create-Biddle in the property modal (optionally after stashing a draft). */
export function openCreateBiddle(
  navigate: NavigateFunction,
  propertyId: string,
  opts?: { pathname?: string; replace?: boolean },
) {
  openPropertyProfile(navigate, propertyId, {
    pathname: opts?.pathname ?? '/biddles',
    replace: opts?.replace,
    create: true,
  })
}

/**
 * Search-tab selection: go to Map, center on the property, open the profile modal.
 */
export function openPropertyProfileOnMap(navigate: NavigateFunction, propertyId: string) {
  openPropertyProfile(navigate, propertyId, { pathname: '/map' })
}

export function closePropertyProfile(navigate: NavigateFunction) {
  const params = new URLSearchParams(window.location.search)
  if (!params.has('property') && !params.has('create')) return
  params.delete('property')
  params.delete('create')
  stripCreatePrefillParams(params)
  const search = params.toString() ? `?${params.toString()}` : ''
  navigate({ pathname: window.location.pathname, search }, { replace: true })
}
